module.exports = __webpack_public_path__ + "static/2-7eef082fb93671877eff57d4ee4f3990.woff";